<template>
  <section v-if="matricula">
    <section>
      <section-header v-if="title1" :current="title1" />
      <section class="form-section">
        <h5>1. Informações Pessoais</h5>
        <pessoas :current="current" :auto="auto" branch="responsavelFinanceiro" v-if="ready"/>
      </section>
      <section class="form-section">
        <h5>2. Endereço</h5>
        <endereco :current="current" :auto="auto" v-if="ready" branch="responsavelFinanceiro"/>
      </section>
    </section>
    <label class="check-control">
      <input type="checkbox" class="check" value="1" v-model="matricula.responsavelFinanceiroEPedagogico" >
      <span>O responsável Financeiro também é pedagógico</span>
    </label>
    <section v-if="!matricula.responsavelFinanceiroEPedagogico">
      <section-header v-if="title2" :current="title2" />
      <section class="form-section">
        <h5>1. Informações Pessoais</h5>
        <pessoas :current="current" :auto="auto" branch="responsavelPedagogico"  v-if="ready"/>
      </section>
      <section class="form-section">
        <h5>2. Endereço</h5>
        <endereco :current="current" :auto="auto" v-if="ready" branch="responsavelPedagogico"/>
      </section>
    </section>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Pessoas from '@/components/matriculas/4/form/Pessoas.vue'
import Endereco from '@/components/matriculas/4/form/Endereco.vue'
import matriculaService from '@/services/matricula.service';
import { unformatDate } from '@/services/utils.service.js'

export default {
  components: {
    SectionHeader, Pessoas, Endereco
  },
  props: {
    current: Object,
    auto: Boolean,
    action: String,
    step: Object
  },
  data () {
    return {
      ready: false,
      filiacao1: null,
      filiacao2: null,
      enderecoData: null,
      title1: null,
      title2: null,
      matricula: null
    }
  },
  mounted () {
    this.title1 = { title: 'Responsável Financeiro' }
    this.title2 = { title: 'Responsável Pedagógico' }

    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
      console.log("Matricula - Responsavel:", this.matricula)
      this.checkResponsavelFinanceiroEPedagogico()
      if ( this.matricula.matricula.idMatricula ) {
        this.get()
      }

      if(this.matricula.idSituacao == 1) {
        this.disabledAll = true
      }

      this.aluno = response.Aluno
    })
  },
  methods: {
    normalizeResponsavel ( pessoa, type ) {
      const responsavel = pessoa?.Responsavel ?? pessoa?.responsavel ?? null

      if ( Array.isArray(responsavel) ) {
        return responsavel.find(item => {
          return type == 'responsavelFinanceiro'
            ? item.financeiro == 1
            : item.pedagogico == 1
        }) || responsavel[0] || null
      }

      return responsavel
    },
    getResponsavelIdPessoa ( type ) {
      return this.matricula?.[type]?.Basicos?.idPessoa ||
        this.matricula?.[type]?.documento?.idPessoa ||
        null
    },
    checkResponsavelFinanceiroEPedagogico () {
      const idPessoaFinanceiro = this.getResponsavelIdPessoa('responsavelFinanceiro')
      const idPessoaPedagogico = this.getResponsavelIdPessoa('responsavelPedagogico')

      if ( idPessoaFinanceiro && idPessoaPedagogico && idPessoaFinanceiro == idPessoaPedagogico ) {
        this.matricula.responsavelFinanceiroEPedagogico = true
      }
    },
    get () {
      if ( !this.matricula.responsavelFinanceiro.Basicos.idPessoa ) {
        matriculaService.getRespFin(this.matricula.matricula.idMatricula)
        .then( response => {
          console.log("Responsavel Financeiro:", response.data.pessoa)
          this.matricula.responsavelFinanceiro.Basicos = response.data.pessoa.Basicos ?? null
          this.matricula.responsavelFinanceiro.endereco = response.data.pessoa.Endereco ?? null
          this.matricula.responsavelFinanceiro.documento = { ...response.data.pessoa.Documento }
          this.matricula.responsavelFinanceiro.responsavel = this.normalizeResponsavel(response.data.pessoa, 'responsavelFinanceiro')
          if (this.matricula.responsavelFinanceiro.Basicos?.dataNascimento) {
            this.matricula.responsavelFinanceiro.Basicos.dataNascimento = unformatDate(this.matricula.responsavelFinanceiro.Basicos.dataNascimento)
          }
          this.checkResponsavelFinanceiroEPedagogico()
        })
        .catch( error => {
          console.error(error)
        })
        .finally(() => {

        })
      }
      if ( !this.matricula.responsavelPedagogico.Basicos.idPessoa ) {
        matriculaService.getRespPed(this.matricula.matricula.idMatricula)
        .then( response => {
          console.log("Responsavel Pedagogico:", response.data.pessoa)
          this.matricula.responsavelPedagogico.Basicos = response.data.pessoa.Basicos ?? null
          this.matricula.responsavelPedagogico.endereco = response.data.pessoa.Endereco ?? null
          this.matricula.responsavelPedagogico.documento = { ...response.data.pessoa.Documento }
          this.matricula.responsavelPedagogico.responsavel = this.normalizeResponsavel(response.data.pessoa, 'responsavelPedagogico')
          if (this.matricula.responsavelPedagogico.Basicos?.dataNascimento) {
            this.matricula.responsavelPedagogico.Basicos.dataNascimento = unformatDate(this.matricula.responsavelPedagogico.Basicos.dataNascimento)
          }
          this.checkResponsavelFinanceiroEPedagogico()
        })
        .catch( error => {
          console.error(error)
        })
        .finally(() => {

        })
      }

      this.ready = true
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin-bottom: $hmg_mid;
}

.form-section {
  margin-bottom: $hmg_mid;
}
</style>
